import { render } from "./Games.vue?vue&type=template&id=d2eb427a"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"

import "./Games.vue?vue&type=style&index=0&id=d2eb427a&lang=css"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__